import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DATE_FORMATS } from 'app/shared/constants';
import { DateWithOffsetDirective } from 'app/shared/directives';

@Component({
  selector: 'app-date-column-with-offset',
  imports: [DateWithOffsetDirective],
  templateUrl: './date-column-with-offset.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateColumnWithOffsetComponent implements ICellRendererAngularComp {
  public dateFormats = DATE_FORMATS;

  public text = '';

  public agInit(params: ICellRendererParams): void {
    this.text = params.valueFormatted ?? params.value ?? '';
  }

  public refresh(params: ICellRendererParams<string>): boolean {
    this.text = params.valueFormatted ?? params.value ?? '';
    return true;
  }
}
